import { HttpClient } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { environment } from '../../../../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable()
export class ChangeRoleService {

  constructor(private http: HttpClient) { }

  public invitedMemberChangeOfRole(payload): Observable<any> {
    payload.panelTypeCodeId = +localStorage.getItem("TEAM_CODE")
    if (payload.rgaRoleViewDtoList[0].panelId) {
      payload.disciplinaryPanelId = payload.rgaRoleViewDtoList[0].panelId
      delete payload.rgaRoleViewDtoList[0].panelId
    }
    if (!payload.disciplinaryPanelId) {
      delete payload.rgaRoleViewDtoList[0].panelId
    }

    try {
      return this.http.post(environment.BASE_URL_HRD +
        "tmMng/changeRoleOfInviteUser", payload)
    }
    catch (exception) {
      console.log(exception)
    }

  }

  public notInvitedMemberChangeOfRole(payload): Observable<any> {
    payload.panelTypeCodeId = +localStorage.getItem("TEAM_CODE")
    if (payload.isPanelUpdated) {
      delete payload.isPanelUpdated
    }
    for (let i = 0; i < payload.rgaRoleViewDtoList.length; i++) {
      if (payload.rgaRoleViewDtoList[i].panelId) {
        payload.disciplinaryPanelId = payload.rgaRoleViewDtoList[0].panelId
        delete payload.rgaRoleViewDtoList[i].panelId
      }
      else {
        if (payload.rgaRoleViewDtoList[i].panelId == null) {
          delete payload.rgaRoleViewDtoList[i].panelId
        }
      }
    }

    if (payload.disciplinaryPanelId) {
      payload.addDisciplinaryPanel = true
    }
    else {
      payload.addDisciplinaryPanel = false
    }

    try {
      return this.http.post(environment.BASE_URL_HRD +
        "tmMng/changeOfRoleDetail", payload)
    }
    catch (exception) {
      console.log(exception)
    }

  }

  private notInvitedMemberJmpChangeOfRole(payload): Observable<any> {
    try {
      return this.http.post(environment.BASE_URL_HRD +
        "tmMng/changeRoleOfJmpMember", payload)
    }
    catch (exception) {
      console.log(exception)
    }
  }

  private invitedMemberJmpChangeOfRole(payload): Observable<any> {
    try {
      return this.http.post(environment.BASE_URL_HRD +
        "tmMng/changeRoleOfJmpInviteUser", payload)
    }
    catch (exception) {
      console.log(exception)
    }
  }

  private notInvitedMemberSteeringCommitteeChangeOfRole(payload): Observable<any> {
    try {
      return this.http.post(environment.BASE_URL_HRD +
        "tmMng/changeRoleOfSteeringCommitteeMember", payload)
    }
    catch (exception) {
      console.log(exception)
    }
  }

  private invitedMemberSteeringCommitteeChangeOfRole(payload): Observable<any> {
    try {
      return this.http.post(environment.BASE_URL_HRD +
        "tmMng/changeRoleOfSteeringCommitteeInviteUser", payload)
    }
    catch (exception) {
      console.log(exception)
    }

  }

  private notInvitedMemberHlepChangeOfRole(payload): Observable<any> {
    try {
      return this.http.post(environment.BASE_URL_HRD +
        "tmMng/changeRoleOfHlepMember", payload)
    }
    catch (exception) {
      console.log(exception)
    }

  }

  private invitedMemberHlepChangeOfRole(payload): Observable<any> {
    try {
      return this.http.post(environment.BASE_URL_HRD +
        "tmMng/changeRoleOfHlepInviteUser", payload)
    }
    catch (exception) {
      console.log(exception)
    }

  }

  public invitedChangeOfRole(payload, pageState): Observable<any> {
    if (payload.rgaRoleViewDtoList[0].panelId) {
      payload.disciplinaryPanelId = payload.rgaRoleViewDtoList[0].panelId
      delete payload.rgaRoleViewDtoList[0].panelId
    }
    if (!payload.disciplinaryPanelId) {
      delete payload.rgaRoleViewDtoList[0].panelId
    }
    if (pageState) {
      if (pageState == 'JMP') {
        return this.invitedMemberJmpChangeOfRole(payload)
      }
      else if (pageState == 'Steering Committee') {
        return this.invitedMemberSteeringCommitteeChangeOfRole(payload)
      }
      else if (pageState == 'HLEP') {
        return this.invitedMemberHlepChangeOfRole(payload)
      }
      else {
        return null
      }
    }

  }

  public notInvitedChangeOfRole(payload, pageState): Observable<any> {

    if (payload.isPanelUpdated) {
      delete payload.isPanelUpdated
    }
    if (pageState) {
      if (pageState == 'JMP') {
        return this.notInvitedMemberJmpChangeOfRole(payload)
      }
      else if (pageState == 'Steering Committee') {
        return this.notInvitedMemberSteeringCommitteeChangeOfRole(payload)
      }
      else if (pageState == 'HLEP') {
        return this.notInvitedMemberHlepChangeOfRole(payload)
      }
      else {
        return null
      }
    }

  }

}

